import {
  UserDto,
  ChangeUserPasswordDto,
  CreateStaffUserDto,
  CreateResetPasswordDto,
  ProfileUserDto,
  UpdateStaffDto,
  ChangePasswordDto,
  VerificationUserDto,
  CreateStaffUserResponseDto,
  TableUserDto,
  VerifyAccountDto,
  UserStatusEnum,
} from "../utils/types/user";
import {RoleNameEnum} from "../utils/types/common";
import {http} from "./api/restApiClient";

import {Page, Pageable} from "./api/pagination";

export const UserService = {
  create: (data: CreateStaffUserDto) =>
    http.post<CreateStaffUserResponseDto>("/users", data),

  fetchUsers: (params: any) =>
    http.post<Page<TableUserDto>>("/users/fetch", params),

  delete: (userId: string) => http.delete(`/users/${userId}`),

  find: (userId: string) => http.get<UserDto>(`/users/${userId}`),

  search: (query: string, roles: ReadonlyArray<RoleNameEnum>) =>
    http.get<TableUserDto[]>("/users/query", {
      query,
      roles,
    }),

  resendActivationEmail: (userId: string) =>
    http.put(`/users/${userId}/resend-activation-email`),

  resetPassword: (data: CreateResetPasswordDto) =>
    http.put<CreateResetPasswordDto>("/users/reset-password", data, {
      transformRequest: (data, headers) => {
        delete headers.Authorization;

        return JSON.stringify(data);
      },
    }),

  changePassword: (data: ChangePasswordDto) =>
    http.put<ChangePasswordDto>("/users/change-password", data),

  changeUserPassword: (data: ChangeUserPasswordDto, userId: string) =>
    http.put<ChangeUserPasswordDto>(
      `/users/${userId}/change-user-password`,
      data,
    ),

  verifyAccount: (data: VerificationUserDto) =>
    http.put<VerifyAccountDto>("/users/verify-account", data),

  update: (userId: string, data: UpdateStaffDto) =>
    http.put<UserDto>(`/users/${userId}`, data),

  patch: (userId: string, data: ProfileUserDto) =>
    http.patch<UserDto>(`/users/${userId}`, data),

  putReportingPermissions: (
    userId: string,
    permissions: ReadonlyArray<string>,
  ) => http.put(`/users/${userId}/reporting-permissions`, permissions),

  fetchAll: (
    facilityIds: string[],
    roles: ReadonlyArray<RoleNameEnum>,
    statuses: ReadonlyArray<UserStatusEnum>,
    {sort, ...pageable}: Pageable,
  ) =>
    http.post<Page<TableUserDto>>("/users/fetch", {
      facilityIds: facilityIds ? facilityIds : [],
      pageable: {
        ...pageable,
        properties: sort,
      } as any,
      roles,
      statuses:
        statuses[0] !== null
          ? statuses
          : [UserStatusEnum.NEW, UserStatusEnum.ACTIVE],
    }),
};
